export enum FieldDisplayPolicy {
  None = 'None',
  Ask = 'Ask',
  Require = 'Require',
}
